import { environment } from '../../environments/environment'
import atman_logo from '../../assets/atmanlogo.svg'
import { devTiming } from '../../utils/devTiming'

/**
 * How early okta-auth-js treats the access token as expired. At 300 it drops the
 * token five minutes before its real `exp` — which is what makes the "no access
 * token" recovery path (utils/oktaTokenRecovery.ts) fire in the first place.
 *
 * Dev-only: raise this toward the access token's full lifetime to reproduce that
 * race seconds after login instead of ~an hour in. With Okta's default 3600s
 * token, 3570 means "considered expired 30 seconds after mint".
 *
 *   sessionStorage.setItem('atman.dev.expireEarlySeconds', '3570')
 *   location.reload()   // read once, when OktaAuth is constructed
 *
 * Inert in production builds — 300 is the only value a deployed environment sees.
 */
const expireEarlySeconds = devTiming('expireEarlySeconds', 300)

const oktaAuthConfig = {
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  tokenManager: {
    autoRenew: true,
    expireEarlySeconds,
  },
  //pkce: true,
}

const oktaSignInConfig = {
  baseUrl: environment.okta.baseUrl,
  el: '#widget-container',
  useInteractionCodeFlow: false,
  useClassicEngine: true,
  clientId: environment.okta.clientId,
  redirectUri: window.location.origin + '/login/callback',
  logo: atman_logo,
  logoText: 'Atman Health',
  helpSupportNumber: '',
  brandName: '',
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  flow: 'login',
  services: {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
    renewOnTabActivation: true,
    tabInactivityDuration: 1800, // seconds
  },
  tokenManager: {
    autoRenew: true,
    expireEarlySeconds: 300, // Consider token expiring 5 minutes early
  },
  // customButtons: [
  //   {
  //     i18nKey: 'customADButton.title',
  //     className: 'btn-customAuth',
  //     click: () => {
  //       window.location.href = `https://outlook.office.com/?client_id=${environment.okta.clientId}&redirect_uri=https://login.microsoftonline.com/f509e65c-8e0b-472d-b270-6ed49b8329dd/saml2`
  //     },
  //   },
  // ],
  // i18n: {
  //   en: {
  //     'primaryauth.title': 'Atman Health Sign in ',
  //     'primaryauth.username.placeholder': 'Username',
  //     'primaryauth.password.placeholder': 'Password',
  //     // Errors
  //     'error.username.required': 'Please enter an username',
  //     'error.password.required': 'Please enter a password',
  //     'errors.E0000004': 'Sign in failed!',
  //     'customButton.title': 'Atman Sign in ',
  //     'customADButton.title': 'Microsoft AD sign-in',
  //   },
  // },
  authParams: {
    // If your app is configured to use the Implicit flow
    // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
    // you will need to uncomment the below line
    // pkce: false
  },
  features: {
    idpDiscovery: true,
  },
  idpDiscovery: {
    // requestContext: 'https://atmanhealth.okta.com/home/oidc_client/0oa72zlq3nFn8ZYiG5d7/aln177a159h7Zf52X0g8'
    requestContext: window.location.href,
  },
  // Additional documentation on config options can be found at https://github.com/okta/okta-signin-widget#basic-config-options
}

const oidcConfig = {
  authority: environment.oidc.authority,
  clientId: environment.oidc.clientId,
  redirectUri: environment.oidc.redirectUri,
  // postLogoutRedirectUri (camelCase) is what oidc-react@3.x reads — snake_case is ignored
  postLogoutRedirectUri: `${window.location.origin}/login`,
  scope: `openid profile email api://${environment.oidc.clientId}/access_as_user`,
  responseType: 'code',
  loadUserInfo: false, // Disable userinfo fetch - profile data is already in the ID token
}

export { oktaAuthConfig, oktaSignInConfig, oidcConfig }
